<template functional>
  <q-tooltip
    :anchor="props.anchor"
    :self="props.self"
    :content-style="{
      zIndex: 99999,
      padding: 'var(--r-space-sm)',
      background: 'var(--r-secondary-1)',
      overflow: 'hidden',
      ...props.contentStyle
    }"
    :offset="props.offset"
    v-bind="data.attrs"
  >
    <slot />
  </q-tooltip>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    offset: {
      type: Array,
      default: () => [0, 10]
    },
    anchor: {
      type: String,
      default: 'top right'
    },
    self: {
      type: String,
      default: 'center left'
    },
    contentStyle: Object
  }
}
</script>
